import React, { useEffect } from 'react';
import { useGetTermsConditionsQuery } from '../../store/api/landingApi';
import LandingFooter from '../../components/layouts/LandingFooter';
import AOS from 'aos';
import 'aos/dist/aos.css';

const TermsConditions: React.FC = () => {
  const { data, isLoading } = useGetTermsConditionsQuery({ language: localStorage.getItem('locale') || 'en' });

  useEffect(() => {
    AOS.init({ duration: 1000, delay: 300 });
  }, []);

  if (isLoading) return <div>Loading...</div>;

  const page = data?.data?.page;

  return (
    <>
      <div className="d-flex flex-column bg-base-gradient flex-center w-100 min-h-200px z-index-n1 min-h-lg-350px px-9">
        <div className="row w-100 mx-auto">
          <div className="col-md-8 mx-auto text-center">
            <div className="mb-lg-10 pt-10 py-lg-5">
              <h1 className="text-base-dark lh-base fw-bold fs-1x fs-lg-3x mb-5 text-uppercase" data-aos="fade-up">
                {page?.title || 'Terms & Conditions'}
              </h1>
              <br />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-n10 mt-lg-n10 z-index-2 min-h-300px inner-box">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-8 mx-auto shadow bg-white px-15 mb-15 inner-content">
              <p className="fs-5 mt-15" data-aos="fade-up" dangerouslySetInnerHTML={{ __html: page?.content || '' }} />
            </div>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default TermsConditions;
